import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

import { DecamelPipe } from '../../../helper/decamel.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

export interface GridTableOptions {
  excludeKeys?: string[];
  formatTime?: string[];
  actionsKey: string;
}

export interface GridTableAction {
  func: (record: any, key: string) => void,
  label: string,
  icon: "edit" | "delete" | "search",
}

@Component({
  selector: 'msh-grid-table',
  standalone: true,
  imports: [MatIconModule, MatMenuModule, DecamelPipe],
  template: `
  @if(headers.length){
    <div class="w-full border border-b-0 rounded-t-md" >
      <!-- Header Row -->
      <div class="grid font-semibold bg-gray-100 text-gray-700 border-b"
        [style.gridTemplateColumns]="gridTemplate"
        >
        @for(h of headers; track h;){
          <div class="p-2 border-r last:border-r-0">
            {{ h | decamel}}
          </div>
        }
      </div>
  
      <!-- Data Rows -->
      @for(row of data; track row[rowIdKey]){
        <div class="grid border-b" [style.gridTemplateColumns]="gridTemplate" (click)="onRecordClickAction(row)">
          @for(key of headers; track key){
            @if(key === options.actionsKey && row[key]; as actions){
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                @for(action of actions; track action){
                  <div class="hover:bg-navy-50 cursor-pointer" (click)="action.func(row, key)" mat-menu-item>
                    <mat-icon>{{action.icon}}</mat-icon>
                    <span>{{action.label}}</span>
                  </div>
                }
              </mat-menu>
            } @else {
              <div class="p-2 border-r last:border-r-0 text-ellipsis overflow-hidden">
                {{ formatValue(row[key], key) }}
              </div>
            }
          }
        </div>
      }
    </div>
  }
  
  @if (!headers.length) {
    <div class="null text-center text-sm">
      {{nullMsg}}
    </div>
  }
  `,
  styles: [`
    :host { display: block; }
    .grid { display: grid; }
  `]
})
export class GridTableComponent implements OnChanges {
  @Input() data: any[] | GridTableAction[] | null = [];
  @Input() options: GridTableOptions = { actionsKey: "_actions"};
  @Input() nullMsg = 'No data available';
  @Input() rowIdKey = 'id';
  @Output() onRecordClick: EventEmitter<string> = new EventEmitter()

  headers: string[] = [];
  gridTemplate = '';

  ngOnChanges() {
    if (this.data && this.data.length > 0) {
      const exclude = this.options.excludeKeys || ["updatedAt", "updatedById", "createdAt"];
      this.headers = Object.keys(this.data[0])
        .filter(k => !exclude.includes(k))
      this.gridTemplate = `repeat(${this.headers.length}, minmax(0, 1fr))`;
    } else {
      this.headers = [];
      this.gridTemplate = '';
    }
  }

  formatValue(value: any, key: string): string {
    const formatTimeKeys = this.options.formatTime || [];
    if (formatTimeKeys.includes(key) && value) {
      const dt = new Date(value);
      return isNaN(dt.getTime()) ? value : dt.toLocaleString();
    }
    return value;
  }

  onRecordClickAction(row: any){
    console.log({row})
    this.onRecordClick.emit(row[this.rowIdKey])
  }
}
